import { debug as log } from 'debug';

const warn = log('HORSETRADER:warn');
const error = log('HORSETRADER:error');
const info = log('HORSETRADER:log');

export const debug = { warn, error, info };
